import { LayoutService } from '../../../services/layout.service';
import { GalleryCategoryFilter, GalleryService } from '../gallery.service';
import { DocScrollerComponent } from '../../../shared/doc-scroller/doc-scroller.component';
import { ActivatedRoute } from '@angular/router';
import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  ViewChild
} from '@angular/core';
import { switchMap, take, takeUntil } from 'rxjs/operators';
import { GalleryCategory, GALLERY_CATEGORIES, GalleryRecord } from 'shared';
import { NbLayoutScrollService } from '@nebular/theme';
import { Subject } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-gallery-category-page',
  templateUrl: './gallery-category-page.component.html',
  styleUrls: ['./gallery-category-page.component.scss']
})
export class GalleryCategoryPageComponent implements OnInit, OnDestroy {
  @ViewChild(DocScrollerComponent, { static: true }) scroller: DocScrollerComponent;
  isHandset = false;
  category: GalleryCategory;
  categoryIndex = '';

  parentCollection = '';

  parentContent = null;
  parentBaseHeight = 0;
  scrollheightAtEnd = 0;

  destroy$ = new Subject<boolean>();

  isBrowser = false;

  filterNatives = false;
  filterSunExposure: string[] = [];

  filters: GalleryCategoryFilter[] = [];

  constructor(
    private activeRoute: ActivatedRoute,
    private layoutService: LayoutService,
    private galleryService: GalleryService,
    private scrollService: NbLayoutScrollService,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  async ngOnInit(): Promise<void> {
    if (this.isBrowser) {
      this.parentContent = document.getElementsByClassName('scrollable-container').item(0);
    }
    this.parentCollection = decodeURIComponent(
      this.activeRoute.snapshot.paramMap.get('collection')
    );
    this.categoryIndex = this.activeRoute.snapshot.paramMap.get('category');
    this.category = GALLERY_CATEGORIES[this.categoryIndex.toUpperCase()];
    this.isHandset = await this.layoutService.$isHandset.pipe(take(1)).toPromise();
    this.scrollService
      .onScroll()
      .pipe(
        takeUntil(this.destroy$),
        switchMap(() => {
          return this.scrollService.getPosition();
        })
      )
      .subscribe((scrollPos) => {
        // const contentEl = document.getElementsByClassName('content').item(0);
        // if (this.parentBaseHeight === 0) {
        //   this.parentBaseHeight = contentEl.clientHeight;
        // }
        // let newHeight = this.parentBaseHeight;
        // if (scrollPos.y <= this.parentBaseHeight && !this.scroller.isEnd) {
        //   newHeight = Math.max(scrollPos.y * 5, this.parentBaseHeight);
        // } else {
        //   newHeight =
        //     this.scroller.docCount * 440 +
        //     (this.isHandset ? this.parentBaseHeight : this.parentBaseHeight * 0.75);
        // }
        // this.renderer.setStyle(contentEl, 'height', `${newHeight}px`);
      });
    this.search();
    // this.searchBatch();
  }

  ngOnDestroy(): void {
    if (this.isBrowser) {
      this.renderer.setStyle(document.getElementsByClassName('content').item(0), 'height', 'unset');
    }
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  async resetScroller() {
    await this.scroller.reset();
  }

  async updateFilters() {
    this.filters = [];

    if (this.filterNatives) {
      this.filters.push({
        fieldPath: 'isNative',
        opStr: '==',
        value: true
      });
    }

    if (this.filterSunExposure.length > 0) {
      this.filters.push({
        fieldPath: 'sunExposure',
        opStr: 'array-contains-any',
        value: this.filterSunExposure
      });
    }
    await this.resetScroller();
    await this.search();
  }

  search(cursors?: Map<number, any[]>): void {
    this.scroller.setQueryObservables([
      this.galleryService.getCategoryScrollerObservable(
        this.parentCollection,
        this.categoryIndex,
        this.isHandset ? 1 : 4,
        this.filters,
        cursors
      )
    ]);
    this.scroller.fetch();
  }

  identify(index, item): string {
    return item.id;
  }
}
